export enum StatusesEnum {
  ACTIVE = 'Active',
  CLOSED = 'Closed',
  HOLD = 'Pending Open',
  CANCELED = 'Canceled Integration',
}
